// action - state management
import { LOGIN, LOGOUT, REGISTER, UPDATE } from './actions';
import { InitialLoginContextProps } from 'types/auth';

// ==============================|| ACCOUNT REDUCER ||============================== //

interface AccountReducerActionProps {
    type: string;
    payload?: InitialLoginContextProps;
}

const initialState: InitialLoginContextProps = {
    isLoggedIn: false,
    isInitialized: false,
    user: null,
    cdkeys: [],
    promotion: undefined
};

// eslint-disable-next-line
const accountReducer = (state = initialState, action: AccountReducerActionProps) => {
    switch (action.type) {
        case REGISTER: {
            const { user } = action.payload!;
            return {
                ...state,
                user
            };
        }
        case LOGIN: {
            const { user, cdkeys, promotion } = action.payload!;
            return {
                ...state,
                isLoggedIn: true,
                isInitialized: true,
                cdkeys,
                user,
                promotion
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isInitialized: true,
                isLoggedIn: false,
                user: null,
                cdkeys: [],
                promotion: undefined
            };
        }
        case UPDATE: {
            const { user, cdkeys } = action.payload!;
            return {
                ...state,
                cdkeys,
                user
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
